import { BookSelectorValue } from 'components/forms/book-selector';
import { convertToDraft } from 'components/text-editor/editor-utils';
import {
  BlockAction,
  BlockType,
  ContentBlock,
  IContent,
  UninitiatedContentBlock,
} from './types';

function handleInit<T extends { data: UninitiatedContentBlock<BlockType>[] }>(
  payload: T
): IContent {
  return {
    isModified: false,
    isInit: true,
    data: payload.data?.map((block) => {
      if (block.type === 'formated-text') {
        let typedBlock = block as UninitiatedContentBlock<'formated-text'>;
        return {
          ...block,
          data: convertToDraft(typedBlock.data),
        } as ContentBlock<'formated-text'>;
      }
      if (block.type === 'key-value') {
        let typedBlock = block as UninitiatedContentBlock<'key-value'>;
        return {
          ...block,
          data: typedBlock.data.map((b) => ({
            ...b,
            value: convertToDraft(b.value),
          })),
        } as ContentBlock<'key-value'>;
      }
      if (block.type === 'plain-text') {
        return block as ContentBlock<'plain-text'>;
      }
      if (block.type === 'books') {
        return block as ContentBlock<'books'>;
      }
      if (block.type === 'events') {
        return block as ContentBlock<'events'>;
      }
      if (block.type === 'posts') {
        return block as ContentBlock<'posts'>;
      }
    }),
  };
}

function handleModify(
  state: IContent,
  payload: ContentBlock<BlockType>
): IContent {
  return {
    ...state,
    isModified: true,
    data: state.data.map((block) =>
      block.id === payload.id ? payload : block
    ),
  };
}

export function BlockReducer(state: IContent, action: BlockAction) {
  let newState: IContent = { ...state };

  switch (action.type) {
    case 'init':
      newState = handleInit(action.payload);
      break;
    case 'modify':
      newState = handleModify(state, action.payload);
      break;
  }

  return newState;
}
